// extracted by mini-css-extract-plugin
module.exports = {"root":"detailsRepresentative_root__M7HdW","title":"detailsRepresentative_title__hOSPE","collapsible":"detailsRepresentative_collapsible__pIja2"};